<script setup lang="ts">
import { APP_CONFIG } from '~/utils/constants'
</script>

<template>
  <div class="absolute inset-0 overflow-hidden pointer-events-none -z-10">
    <!-- Top Right Blob -->
    <div
      class="absolute top-0 right-0 w-[500px] h-[500px] bg-indigo-500/20 rounded-full blur-[100px] mix-blend-screen opacity-50 animate-blob"
    ></div>

    <!-- Bottom Left Blob -->
    <div
      class="absolute bottom-0 left-0 w-[500px] h-[500px] bg-purple-500/20 rounded-full blur-[100px] mix-blend-screen opacity-50 animate-blob animation-delay-2000"
    ></div>

    <!-- Center Blob -->
    <div
      class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-indigo-300/10 dark:bg-indigo-900/10 rounded-full blur-[120px] mix-blend-normal"
    ></div>

    <!-- Grid Pattern overlay -->
    <div
      class="absolute inset-0 opacity-20 brightness-100 contrast-150 mix-blend-overlay"
      :style="{ backgroundImage: `url(${APP_CONFIG.NOISE_SVG_URL})` }"
    ></div>
    <div
      class="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-size-[24px_24px]"
    ></div>
  </div>
</template>

<style scoped>
.animate-blob {
  animation: blob 7s infinite;
}
.animation-delay-2000 {
  animation-delay: 2s;
}
@keyframes blob {
  0% {
    transform: translate(0px, 0px) scale(1);
  }
  33% {
    transform: translate(30px, -50px) scale(1.1);
  }
  66% {
    transform: translate(-20px, 20px) scale(0.9);
  }
  100% {
    transform: translate(0px, 0px) scale(1);
  }
}
</style>
